// extracted by mini-css-extract-plugin
export default {"sample-detail-options":"index_sample-detail-options__4uJcF"};